import { TFunction } from "react-i18next";
import formatDate from "go-core/components/Formatters/FormatDate";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { TransactionInfoApi } from "../../../../../../../../../services/Api/Organization/types";

const infosOrder = [
	"PAYMENT_TERMINAL_TRANSACTION_TYPE",
	"MASKED_CARD_NUMBER",
	"TRANSACTION_CURRENCY",
	"BRAND_NAME_OF_THE_CARD",
	"CARD_READ_TYPE",
	"DATE",
	"TRANSACTION_NUMBER",
	"TRANSACTION_AMOUNT",
	"BILL_NUMBER",
	"TID",
	"MID",
	"ADDRESS_LINE_1",
	"ADDRESS_LINE_2",
	"ADDRESS_LINE_3",
	"AUTHORIZATION_TYPE",
	"AUTHORIZATION_MESSAGE_NUMBER",
	"AUTHORIZATION_CODE",
	"CARDHOLDER_AUTHORIZATION_METHOD",
	"PRINTOUT_CONTEXT",
	"PRINTOUT_TYPE",
	"TERMINAL_PRINTING_INDICATOR",
	"ADDITIONAL_TRANSACTION_FLAG",
];

const getTransactionInfoOrder = (transactionInfos: TransactionInfoApi[]) => {
	if (transactionInfos.length < 5) return transactionInfos;

	return infosOrder
		.map((typeName) => {
			return transactionInfos.find(({ type }) => type === typeName);
		})
		.filter((transactionInfo) => transactionInfo !== undefined);
};

export const getPaymentMethodExternalProvider = (t: TFunction, infos?: TransactionInfoApi[]) => {
	const vendorInfo = infos?.find((info) => info.type === "VENDOR");

	if (!vendorInfo) return undefined;

	return t(`enums.external_payment_provider.${vendorInfo.data}`);
};

export const getTransactionInfosToDisplay = (
	transactionInfos: TransactionInfoApi[],
	expandState: TransactionInfoExpandState
) => {
	const transactionInfosInOrder = getTransactionInfoOrder(transactionInfos);

	if (expandState === TransactionInfoExpandState.INACTIVE || expandState === TransactionInfoExpandState.EXPANDED)
		return transactionInfosInOrder;

	return transactionInfosInOrder.slice(0, 5);
};

export enum TransactionInfoExpandState {
	HIDDEN,
	EXPANDED,
	INACTIVE,
}

export const getTransactionInfoFormattedValue = (type: string, data: string, currency: string) => {
	if (type === "TIP_AMOUNT" || type === "TRANSACTION_AMOUNT") {
		return FormatMoney({ amount: Number(data), currency });
	}

	if (type === "DATE") {
		return formatDate(data, undefined, true);
	}

	return data;
};

// t("enums.external_payment_provider.E_SERVICE")
